import React from 'react';
import NotFound from './index';

const PageNotFound = () => (
  <NotFound
    title="404"
    subtitle="Sorry. We couldn't find the page you're looking for."
    redirectMessage="Go to NFIB.com"
    handleRedirect={() => {
      window.location.href = 'https://www.nfib.com';
    }}
  />
);

export default PageNotFound;



// WEBPACK FOOTER //
// ./src/common/components/NotFound/PageNotFound.js